import { testimonials } from '@/mocks/testimonials';

export default function Testimonials() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        {/* Section Header */}
        <div className="mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 bg-white border border-background-200 rounded-full text-xs font-medium text-foreground-600 mb-4">
            Community Voice
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
            Real Buyers.
            <br />
            Real Reviews.
          </h2>
        </div>

        {/* Testimonial Cards - Masonry-like grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {testimonials.map((t, idx) => (
            <div
              key={t.id}
              className={`bg-white border border-background-200 rounded-lg p-5 md:p-6 ${idx % 3 === 1 ? 'md:mt-8' : idx % 3 === 2 ? 'md:mt-4' : ''}`}
            >
              {/* Avatar + Name */}
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full bg-background-200 overflow-hidden flex-shrink-0">
                  <img
                    src={t.avatar}
                    alt={t.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <p className="font-semibold text-sm text-foreground-900">{t.name}</p>
                  <p className="text-xs text-foreground-500">{t.handle}</p>
                </div>
              </div>
              {/* Review Text */}
              <p className="text-sm text-foreground-700 leading-relaxed">
                &ldquo;{t.text}&rdquo;
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}